import DOMPurify from "dompurify";

// Quill에서 허용하는 서식 태그만 통과시킨다.
const ALLOWED_TAGS = [
  "p",
  "br",
  "span",
  "strong",
  "b",
  "em",
  "i",
  "u",
  "s",
  "strike",
  "blockquote",
  "ol",
  "ul",
  "li",
  "h1",
  "h2",
  "h3",
  "h4",
  "a",
  "pre",
  "code",
  "sub",
  "sup",
  "img",
];

const ALLOWED_ATTR = ["href", "target", "rel", "class", "style", "src", "alt", "width", "height"];

// 저장된 HTML을 화면에 그리기 전에 XSS 위험 요소를 제거한다.
export const sanitizeHtml = (html?: string | null): string => {
  if (!html) return "";
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i,
  });
};

// 목록/미리보기용으로 HTML 태그를 제거하고 텍스트만 추출한다.
export const htmlToPlainText = (html?: string | null): string => {
  if (!html) return "";
  const div = document.createElement("div");
  div.innerHTML = sanitizeHtml(html);
  return (div.textContent || div.innerText || "").replace(/\s+/g, " ").trim();
};

// Quill 빈 본문("<p><br></p>" 등)을 빈 값으로 판정한다.
export const isEmptyHtml = (html?: string | null): boolean => htmlToPlainText(html).length === 0;
